// const BASE_URL = "https://localhost:7231/api/Department";

import { BASE_URL } from "../config";

// /api/Department/departments
export const getAllDepartment = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Department/departments`);
    if (!response.ok) {
      throw new Error("Failed to fetch departments");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const updateDepartment = async (id, department) => {
  try {
    const trUser = sessionStorage.getItem("username") || "guest";
    const response = await fetch(`${BASE_URL}/Department/departments/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        departmentID: id,
        departmentName: department.departmentName,
        incharge: department.incharge || null,
        departmentDescription: department.departmentDescription || null,
        trUser: trUser,
        trDate: new Date().toISOString(),
        deleted: "N",
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to update department");
    }
    return await response.json();
  } catch (error) {
    console.error("Error updating department:", error);
    throw error;
  }
};


export const addDepartment = async (department) => {
  try {
    const crUser = sessionStorage.getItem("username") || "guest"; // fallback if missing

    const response = await fetch(`${BASE_URL}/Department/departments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...department,
        crUser: crUser,
        crDate: new Date().toISOString(),
        deleted: "N",
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add department");
    }

    return response.status === 201 ? true : await response.json();
  } catch (error) {
    console.error("Error adding department:", error);
    throw error;
  }
};


export const deleteDepartment = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/Department/departments/${id}`, {
      method: "DELETE",
    });

    if (response.status === 204) {
      return true; // successfully deleted
    } else {
      throw new Error("Failed to delete department");
    }
  } catch (error) {
    console.error("Error deleting department:", error);
    throw error;
  }
};
